import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class WaterResourcePressureUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'water-resource-pressure'
  readonly name = 'Presión sobre Recursos Hídricos'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
